import { toast } from "react-toastify";

import { persistor } from "../../redux/Store";
import { reset } from "../../redux/reducers/login";
import { resetHomeRe } from "../../redux/reducers/homeReducer";
import { resetContact } from "../../redux/reducers/contactReducer";
import { paths } from "../../config/constants";

export const clearSession = async (dispatch) => {
  console.log("========== CLEAR SESSION CALLED ==========");
  console.trace("clearSession caller");

  // Notify other tabs
  localStorage.setItem("logout", Date.now().toString());

  // Stop redux-persist before clearing
  persistor.pause();

  // Reset Redux state
  dispatch(resetContact());
  dispatch(resetHomeRe());
  dispatch(reset());

  // Make sure Redux changes are written
  await persistor.flush();

  // Remove persisted Redux data
  await persistor.purge();

  // Clear localStorage except logout
  Object.keys(localStorage).forEach((key) => {
    if (key !== "logout") {
      localStorage.removeItem(key);
    }
  });

  // Clear sessionStorage
  sessionStorage.clear();

  console.log("========== CLEAR SESSION FINISHED ==========");

  // ✅ resume persistence so the next login is saved
    persistor.persist();

};

export const logoutUser = async ({
  dispatch,
  navigate,
  showToast = true,
  expired = false,
  reason = "unknown",
}) => {
  console.log("======================================");
  console.log("LOGOUT USER CALLED");
  console.log("Reason:", reason);
  console.log("Expired:", expired);
  console.log("Time:", new Date().toISOString());
  console.trace("logoutUser caller");
  console.log("======================================");

  if (expired) {
    toast.error("Session Expired!", {
      autoClose: 2500,
    });
  }

  await clearSession(dispatch);

  if (showToast && !expired) {
    toast.success("Logout Successfully!", {
      autoClose: 2500,
    });
  }

  navigate(paths.accounts.login, {
    replace: true,
  });
};